import { createFileRoute } from '@tanstack/react-router'
import { Button } from '@deepguide-ai/ui/button'
import { ExternalLink, ShieldCheck } from 'lucide-react'
import { anonymousReportUrl } from '@/lib/anonymous-report'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/anonymous-reporting'
)({ component: AnonymousReportingPage })

export function AnonymousReportingPage() {
  const { workspaceId } = Route.useParams()
  return (
    <section className='border-border bg-card max-w-2xl space-y-5 rounded-sm border p-6'>
      <div className='space-y-3'>
        <ShieldCheck className='text-text-subtle size-6' aria-hidden='true' />
        <h2 className='font-heading text-foreground text-base font-semibold'>
          Submit an anonymous report
        </h2>
        <p className='font-body text-text-body text-sm leading-relaxed'>
          Use this channel to raise concerns about misconduct, security, or
          other issues that need attention.
        </p>
      </div>
      <div className='font-body text-muted-foreground space-y-3 text-sm leading-relaxed'>
        <p>
          The report form opens separately in a new tab. Your account and IP
          address are not stored with your report.
        </p>
        <p>
          Avoid including identifying details in your report or attachments if
          you wish to remain anonymous. You will not receive status updates or
          replies.
        </p>
      </div>
      <Button asChild size='sm'>
        <a
          href={anonymousReportUrl(workspaceId)}
          target='_blank'
          rel='noopener noreferrer'
          referrerPolicy='no-referrer'
        >
          Open anonymous reporting form
          <ExternalLink className='size-4' aria-hidden='true' />
        </a>
      </Button>
    </section>
  )
}
